import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const useTranslate = (component: string) => {
    const { t } = useTranslation('translation', {
        keyPrefix: component
    });

    return useCallback((key: string, params = {}) => t(key, params), [t]);
};

export default useTranslate;
